import Component from 'vue-class-component';
import BasketAbstract from '../BasketAbstract/BasketAbstract';
import { Model } from 'vue-property-decorator';

@Component({
})
export default class TheMenuBasket extends BasketAbstract {
    @Model('change', {default: false}) open!: boolean
}